import { PapeisResponse } from 'model/reino/MembroUnidade';
import { Api } from '../Api';
import { ApiAxios } from '../ApiAxios';


export class ApiPermissoes {

  static async papeis(): Promise<PapeisResponse> {
    const response = await ApiAxios.instance.get(`reinos/${Api.REINO_PADRAO}/papeis`)

    // FIXME RETRY OP#5440
    // retryDelay: ({ attempt, error, response }) => {
    //   const cincoSegundos = 5000
    //   const tempoExponencial = attempt > 1 ? 2 ** attempt * cincoSegundos : cincoSegundos;
    //   return Math.min(tempoExponencial, 30 * 1000)
    // }
    
    return response.data;
  }
}
